import { FC } from 'react';
import {
  Spacer,
  Button,
  TextSubtitle,
  TextBody,
  Stack,
  Divider,
} from '@pypestream/design-system';
import { TranslationComponent } from '@pypestream/translations';

import { GenericPopover, GenericPopoverProps } from '../generic-popover';

export type DeleteTaskPopoverProps = GenericPopoverProps & {
  taskName?: string;
  onDelete?: () => void;
};

export const DeleteTaskPopover: FC<DeleteTaskPopoverProps> = ({
  trigger,
  popoverRef,
  testId,
  taskName,
  onClose,
  onDelete,
}) => {
  return (
    <GenericPopover
      testId={testId}
      width="auto"
      trigger={trigger}
      popoverRef={popoverRef}
      onClose={onClose}
    >
      <div style={{ width: 272 }}>
        <TextSubtitle size="small" textAlign="center">
          <TranslationComponent i18nKey="pro-studio/common:deleteTaskModal.title">
            Delete Task?
          </TranslationComponent>
        </TextSubtitle>
        <Spacer size="xsmall" />
        <TextBody variant="secondary" size="small" textAlign="center">
          <TranslationComponent
            i18nKey="pro-studio/common:deleteTaskModal.description"
            values={{ taskName: taskName || 'this task' }}
          >
            Once deleted, this task and its description cannot be recovered. Are
            you sure you want to continue?
          </TranslationComponent>
        </TextBody>
        <Spacer size="xsmall" />
        <Divider />
        <Spacer size="xsmall" />
        <Stack gutter="xsmall" direction="row" nowrap>
          <Button
            variant="secondary"
            size="medium"
            onClick={onClose}
            width="full"
          >
            <TranslationComponent i18nKey="pro-studio/common:deleteFilePopover.cancel">
              Cancel
            </TranslationComponent>
          </Button>
          <Button
            variant="danger"
            size="medium"
            onClick={() => {
              onDelete?.();
              onClose?.();
            }}
            width="full"
          >
            <TranslationComponent i18nKey="pro-studio/common:deleteFilePopover.delete">
              Delete Task
            </TranslationComponent>
          </Button>
        </Stack>
      </div>
    </GenericPopover>
  );
};
